var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoNewUc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-new-uc",
    transform: "translate(-2270.387 -10303.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 40,
    height: 40,
    transform: "translate(2270.387 10303.25)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_new-uc",
    transform: "translate(2266.887 10287.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_55",
    "data-name": "Trac\\xE9 55",
    d: "M8.5,33A1.5,1.5,0,0,1,10,31.5H37A1.5,1.5,0,0,1,38.5,33v6.5A1.5,1.5,0,0,1,37,41H10a1.5,1.5,0,0,1-1.5-1.5V33M7,33v6.5a3,3,0,0,0,3,3H37a3,3,0,0,0,3-3V33a3,3,0,0,0-3-3H10a3,3,0,0,0-3,3Zm18.5,5.75h0a.749.749,0,0,0-.75-.75h-5a.749.749,0,0,0-.75.75h0a.749.749,0,0,0,.75.75h5A.749.749,0,0,0,25.5,38.75Zm-8,0h0a.749.749,0,0,0-.75-.75h-5a.749.749,0,0,0-.75.75h0a.749.749,0,0,0,.75.75h5A.749.749,0,0,0,17.5,38.75Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_56",
    "data-name": "Trac\\xE9 56",
    d: "M56.5,36A2.5,2.5,0,1,0,59,38.5,2.5,2.5,0,0,0,56.5,36Zm0,3.5a1,1,0,1,1,1-1A1,1,0,0,1,56.5,39.5Z",
    transform: "translate(-23.5 -3)",
    fill: "#646464"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNewUc);
export default __webpack_public_path__ + "static/media/ico-new-uc.a624bda7fd7ddb9c6e17fb2a22a6951e.svg";
export { ForwardRef as ReactComponent };